import { AplosFileContentType } from "./AplosFileContentType";
import { GetAplosFileArgs, GetAplosFileArgsOptions } from "./GetAplosFileArgs";

export interface GetAplosFileDataArgsOptions extends GetAplosFileArgsOptions {
    contentType?: AplosFileContentType;
}

export class GetAplosFileDataArgs extends GetAplosFileArgs {

    public base64Encode?: boolean;
    public contentType?: AplosFileContentType;

    constructor(options: GetAplosFileDataArgsOptions) {
        super(options);
        this.contentType = options.contentType;
    }

}